/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Spa_RenderingInputs */

const en_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPA rendering`)
};

const ar_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض التطبيق أحادي الصفحة`)
};

const bn_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPA রেন্ডারিং`)
};

const de_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPA-Rendering`)
};

const es_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representación SPA`)
};

const fr_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendu SPA`)
};

const pt_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderização SPA`)
};

const zh_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPA 渲染`)
};

const tr_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPA oluşturma`)
};

const ru_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPA-рендеринг`)
};

const pl_svchip_spa_rendering = /** @type {(inputs: Svchip_Spa_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderowanie SPA`)
};

/**
* | output |
* | --- |
* | "SPA rendering" |
*
* @param {Svchip_Spa_RenderingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_spa_rendering = /** @type {((inputs?: Svchip_Spa_RenderingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Spa_RenderingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_spa_rendering(inputs)
	if (locale === "bn") return bn_svchip_spa_rendering(inputs)
	if (locale === "de") return de_svchip_spa_rendering(inputs)
	if (locale === "es") return es_svchip_spa_rendering(inputs)
	if (locale === "fr") return fr_svchip_spa_rendering(inputs)
	if (locale === "pt") return pt_svchip_spa_rendering(inputs)
	if (locale === "zh") return zh_svchip_spa_rendering(inputs)
	if (locale === "tr") return tr_svchip_spa_rendering(inputs)
	if (locale === "ru") return ru_svchip_spa_rendering(inputs)
	if (locale === "pl") return pl_svchip_spa_rendering(inputs)
	return en_svchip_spa_rendering(inputs)
});